<div class="content container-fluid">
  <h1>Attendance</h1>
  <div class="col-xxl-12 col-xl-8">
    <div class="card">
      <!-- <div class="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3"> -->
      <!-- <h5>Roles & Permission Sets</h5> -->
      <!-- <div class="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3"> -->
      <div class="card-header d-flex align-items-center justify-content-start flex-wrap row-gap-3">
        <div class="d-flex my-xl-auto align-items-center flex-wrap row-gap-3">
          <!-- <div class="dropdown me-3">
          <selectf
            class="form-select"
            [(ngModel)]="selectedBusinessId"
            (change)="onBusinessChange(selectedBusinessId)"
          >
            <option value="" selected>Select Business Entity</option>
            <option *ngFor="let business of businesses$ | async" [value]="business.id">
              {{ business.businessName | capitalize }}
            </option>
          </select>
        </div> -->
          <ng-select
            *appHasPermission="{ business: ['view'], employees: ['view'] }"
            class="me-3"
            [items]="businesses$ | async"
            bindValue="id"
            placeholder="Select Business Entity"
            [searchable]="true"
            [clearable]="false"
            [searchFn]="customSearchFn"
            style="width: 200px"
            [(ngModel)]="selectedBusinessId"
            (change)="onBusinessChange(selectedBusinessId)"
          >
            <ng-template ng-label-tmp let-item="item">
              {{ item.businessName | capitalize }}
            </ng-template>
            <ng-template ng-option-tmp let-item="item">
              {{ item.businessName | capitalize }}
            </ng-template>
          </ng-select>

          <!-- <div class="dropdown me-3">
          <select
            class="form-select"
            [(ngModel)]="selectedEmployeeId"
            (change)="onEmployeeChange(selectedEmployeeId)"
          >
            <option value="" selected disabled>Select Employee</option>
            <option *ngFor="let employee of employees$ | async" [value]="employee.id">
              {{ employee.firstName | capitalize }} {{ employee.lastName  }}
            </option>
          </select>
        </div> -->
          <ng-select
            *appHasPermission="{ employees: ['view'] }"
            class="me-3"
            [items]="employees$ | async"
            bindValue="id"
            placeholder="Select Employee"
            [searchable]="true"
            [clearable]="false"
            [searchFn]="customSearchFnEmployee"
            style="width: 200px"
            [(ngModel)]="selectedEmployeeId"
            (change)="
              onEmployeeChange(selectedEmployeeId); loadAssignedLeavePolicy(selectedEmployeeId)
            "
          >
            <ng-template ng-label-tmp let-item="item">
              {{ item.firstName | capitalize }} {{ item.lastName | capitalize }}
            </ng-template>
            <ng-template ng-option-tmp let-item="item">
              {{ item.firstName | capitalize }} {{ item.lastName | capitalize }}
            </ng-template>
          </ng-select>

          <!-- <ng-select
          [items]="countries$ | async"
          bindValue="id"
          placeholder="Select Country"
          [searchable]="true"
          [clearable]="true"
          [(ngModel)]="selectedCountryId"
          [searchFn]="customSearchFnCountry"
          (change)="onCountryChange($event)"
          style="width: 200px"
        >
          <ng-template ng-option-tmp let-country="item">
            <div>
              <div class="fw-bold">{{ country.name }}</div>
              <small *ngIf="country.timezones?.length">
                <div *ngFor="let tz of country.timezones">
                  {{ tz.gmtOffsetName }} - {{ tz.tzName }} ({{ tz.zoneName }})
                </div>
              </small>
            </div>
          </ng-template>
        </ng-select> -->
          <ng-select
            class="me-3"
            [items]="timezoneOptions"
            bindValue="zoneName"
            bindLabel="label"
            placeholder="Select Timezone"
            [searchable]="true"
            [clearable]="false"
            [(ngModel)]="selectedZoneName"
            [searchFn]="customSearchFnTimezone"
            (change)="onTimezoneChange($event)"
            style="width: 300px"
          >
            <!-- Custom display in dropdown -->
            <ng-template ng-option-tmp let-item="item">
              <div>
                <div class="fw-bold">{{ item.countryName }}</div>
                <small>{{ item.label }}</small>
              </div>
            </ng-template>

            <!-- Custom display in selected box -->
            <ng-template ng-label-tmp let-item="item">
              {{ item.label }}
            </ng-template>
          </ng-select>
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-xxl-10 col-xl-8 theiaStickySidebar">
      <div class="card">
        <div class="card-body">
          <full-calendar #fullcalendar [options]="calendarOptions" id="calendar"> </full-calendar>
        </div>
      </div>
    </div>

    <!-- Calendar Sidebar -->
    <div class="col-xxl-2 col-xl-4">
      <div class="card">
        <div class="card-body p-3">
          <div class="border-bottom pb-2 mb-4">
            <div class="datepic"></div>
          </div>

          <!-- regularize -->
          <div class="border-bottom pb-4 mb-4">
            <!-- <div class="d-flex align-items-center justify-content-between mb-2"> -->
            <!-- <a
              href="javascript:void(0)"
              class="btn btn-white border-primary text-primary w-100 mb-2"
              data-bs-toggle="offcanvas"
              data-bs-target="#offcanvasRightRegularizeAttendance"
              aria-controls="offcanvasRightRegularizeAttendance"
              (click)="regularizeAttendanceDrawer('Regularize Attendance')"
              [class.disabled]="attendanceOffCanvas"
              [attr.aria-disabled]="attendanceOffCanvas"
              >Regularize Attendance</a
            > -->
            <a
              href="javascript:void(0)"
              class="btn btn-white border-primary text-primary w-100 mb-2"
              [class.disabled]="attendanceOffCanvas"
              [attr.tabindex]="attendanceOffCanvas ? -1 : 0"
              data-bs-toggle="offcanvas"
              data-bs-target="#offcanvasRightRegularizeAttendance"
              aria-controls="offcanvasRightRegularizeAttendance"
              (click)="
                attendanceOffCanvas
                  ? $event.preventDefault()
                  : regularizeAttendanceDrawer('Regularize Attendance')
              "
            >
              Regularize Attendance
            </a>

            <a
              href="javascript:void(0)"
              class="btn btn-white border-primary text-primary w-100 mb-2"
              data-bs-toggle="offcanvas"
              data-bs-target="#offcanvasRightCompOff"
              aria-controls="offcanvasRightCompOff"
              (click)="
                employeesCount === 0
                  ? $event.preventDefault()
                  : requestCompoffDrawer('Comp Off Request')
              "
              *ngIf="compoffVisible"
              [class.disabled]="employeesCount === 0"
              [attr.aria-disabled]="employeesCount === 0"
              [attr.tabindex]="employeesCount === 0 ? -1 : 0"
              >Request Comp Off</a
            >
            <a
              *appHasPermission="{ leaves: ['view'] }"
              href="javscript:void(0)"
              [routerLink]="
                employeesCount === 0
                  ? null
                  : user?.employmentType === 'Business Owner'
                    ? eps.leaves.leavesRequestPath
                    : eps.leaves.appliedLeavePath
              "
              [queryParams]="{
                openModal: true,
                businessId: selectedBusinessId,
                userId: selectedEmployeeId
              }"
              class="btn btn-white border-primary text-primary w-100 mb-2"
              [class.disabled]="employeesCount === 0"
              [attr.aria-disabled]="employeesCount === 0"
              [attr.tabindex]="employeesCount === 0 ? -1 : 0"
              data-bs-toggle="modal"
              data-bs-target="#add_leaves"
              >Apply Leave</a
            >

            <a
              *appHasPermission="{ calendarEvent: ['view'] }"
              href="javscript:void(0)"
              class="btn btn-white border-primary text-primary w-100 mb-2"
              (click)="
                employeesCount === 0
                  ? $event.preventDefault()
                  : openBusinessModal(addBusinessModals)
              "
              [class.disabled]="employeesCount === 0"
              [attr.aria-disabled]="employeesCount === 0"
              [attr.tabindex]="employeesCount === 0 ? -1 : 0"
            >
              Create Event
            </a>
            <!-- <a
              *appHasPermission="{ leave: ['view'] }"
              href="javscript:void(0)"
              [routerLink]="eps.leaves.leavesRequestPath"
              class="btn btn-dark w-100"
              data-bs-toggle="modal"
              data-bs-target="#add_leaves"
              >Apply New Leave</a
            > -->
            <!-- <a class="btn btn-white border-primary text-primary w-100 mb-2">Apply Leave</a> -->
            <!-- </div> -->
          </div>
          <!-- regularize end -->

          <!-- Event -->
          <div class="border-bottom pb-4 mb-4 d-none">
            <div class="d-flex align-items-center justify-content-between mb-2">
              <h5>Event</h5>
              <a href="#" class="link-primary" data-bs-toggle="modal" data-bs-target="#add_event"
                ><i class="ti ti-square-rounded-plus-filled fs-16"></i
              ></a>
            </div>
            <p class="fs-12 mb-2">Drag and drop your event or click in the calendar</p>
            <div id="external-events">
              <div
                class="fc-event bg-transparent-success mb-1"
                data-event='{ "title": "Team Events" }'
                data-event-classname="bg-transparent-success"
              >
                <i class="ti ti-square-rounded text-success me-2"></i>Team Events
              </div>
              <div
                class="fc-event bg-transparent-warning mb-1"
                data-event='{ "title": "Team Events" }'
                data-event-classname="bg-transparent-warning"
              >
                <i class="ti ti-square-rounded text-warning me-2"></i>Work
              </div>
              <div
                class="fc-event bg-transparent-danger mb-1"
                data-event='{ "title": "External" }'
                data-event-classname="bg-transparent-danger"
              >
                <i class="ti ti-square-rounded text-danger me-2"></i>External
              </div>
              <div
                class="fc-event bg-transparent-skyblue mb-1"
                data-event='{ "title": "Projects" }'
                data-event-classname="bg-transparent-skyblue"
              >
                <i class="ti ti-square-rounded text-skyblue me-2"></i>Projects
              </div>
              <div
                class="fc-event bg-transparent-purple mb-1"
                data-event='{ "title": "Applications" }'
                data-event-classname="bg-transparent-purple"
              >
                <i class="ti ti-square-rounded text-purple me-2"></i>Applications
              </div>
              <div
                class="fc-event bg-transparent-info mb-0"
                data-event='{ "title": "Desgin" }'
                data-event-classname="bg-transparent-info"
              >
                <i class="ti ti-square-rounded text-info me-2"></i>Desgin
              </div>
            </div>
          </div>
          <!-- /Event -->

          <!-- Upcoming Event -->
          <div class="border-bottom pb-2 mb-4 d-none">
            <h5 class="mb-2">
              Upcoming Event<span class="badge badge-success rounded-pill ms-2">15</span>
            </h5>
            <div class="border-start border-purple border-3 mb-3">
              <div class="ps-3">
                <h6 class="fw-medium mb-1">Meeting with Team Dev</h6>
                <p class="fs-12"><i class="ti ti-calendar-check text-info me-2"></i>15 Mar 2025</p>
              </div>
            </div>
            <div class="border-start border-pink border-3 mb-3">
              <div class="ps-3">
                <h6 class="fw-medium mb-1">Design System With Client</h6>
                <p class="fs-12"><i class="ti ti-calendar-check text-info me-2"></i>24 Mar 2025</p>
              </div>
            </div>
            <div class="border-start border-success border-3 mb-3">
              <div class="ps-3">
                <h6 class="fw-medium mb-1">UI/UX Team Call</h6>
                <p class="fs-12"><i class="ti ti-calendar-check text-info me-2"></i>28 Mar 2025</p>
              </div>
            </div>
          </div>
          <!-- /Upcoming Event -->

          <!-- Upgrade Details -->
          <div class="bg-dark rounded text-center position-relative p-4 d-none">
            <span class="avatar avatar-lg rounded-circle bg-white mb-2">
              <i class="ti ti-alert-triangle text-dark"></i>
            </span>
            <h6 class="text-white mb-3">Enjoy Unlimited Access on a small price monthly.</h6>
            <a href="#" class="btn btn-white">Upgrade Now <i class="ti ti-arrow-right"></i></a>
            <div class="box-bg">
              <span class="bg-right"
                ><img
                  src="https://smarthr.dreamstechnologies.com/html/template/assets/img/bg/email-bg-01.png"
                  alt="Img"
              /></span>
              <span class="bg-left"
                ><img
                  src="https://smarthr.dreamstechnologies.com/html/template/assets/img/bg/email-bg-02.png"
                  alt="Img"
              /></span>
            </div>
          </div>
          <!-- /Upgrade Details -->
        </div>
      </div>
    </div>
    <!-- /Calendar Sidebar -->
  </div>
</div>

<!-- Attendance policy offcanvas -->
<div
  class="offcanvas offcanvas-end"
  style="width: 600px !important"
  data-bs-scroll="true"
  tabindex="-1"
  id="offcanvasRightRegularizeAttendance"
  aria-labelledby="offcanvasRightLabel"
>
  <div class="offcanvas-header">
    <h5 id="offcanvasRightLabel">
      {{ offcanvasTitle }}
    </h5>
    <button
      type="button"
      class="btn-close text-reset"
      data-bs-dismiss="offcanvas"
      aria-label="Close"
      (click)="onClose()"
    ></button>
  </div>
  <!-- end offcanvas-header-->

  <div class="offcanvas-body">
    <h5 class="mt-3">Want to regularize for a different date?</h5>
    <form [formGroup]="rangeForm">
      <input
        appTrimInput
        type="text"
        id="dateRangeInputModal"
        class="btn btn-light date-range bookingrange"
        formControlName="daterange"
        placeholder="dd/mm/yyyy - dd/mm/yyyy"
        bsdaterangepicker
        style="width: 250px"
      />

      <!-- Accordion Container -->
      <div class="accordion mt-3" id="dateAccordion"></div>

      <!-- <ng-container *appHasPermission="{ attendance: ['view'] }"> -->
      <button
        class="btn btn-primary mt-4 w-50"
        type="button"
        (click)="submitForm('Attendance Regularization')"
        [disabled]="dates.length === 0 || hasOnlyAttendanceViewPermission"
      >
        Submit Regularized Attendance
      </button>
      <!-- </ng-container> -->
    </form>
  </div>
  <!-- end offcanvas-body-->
</div>
<!-- end offcanvas-->

<!-- comp off request offcanvas -->
<div
  class="offcanvas offcanvas-end"
  style="width: 600px !important"
  data-bs-scroll="true"
  tabindex="-1"
  id="offcanvasRightCompOff"
  aria-labelledby="offcanvasRightcompoffLabel"
>
  <div class="offcanvas-header">
    <h5 id="offcanvasRightcompoffLabel">
      {{ offcanvasTitle }}
    </h5>
    <button
      type="button"
      class="btn-close text-reset"
      data-bs-dismiss="offcanvas"
      aria-label="Close"
      (click)="onClose()"
    ></button>
  </div>
  <!-- end offcanvas-header-->

  <div class="offcanvas-body">
    <h5 class="mt-3">Select dates to apply Comp Off Request</h5>
    <form [formGroup]="rangeForm">
      <input
        appTrimInput
        type="text"
        id="dateRangeInputCompoffModal"
        class="btn btn-light date-range bookingrange"
        formControlName="daterange"
        placeholder="dd/mm/yyyy - dd/mm/yyyy"
        bsdaterangepicker
        style="width: 250px"
      />

      <!-- Accordion Container -->
      <div class="accordion mt-3" id="dateCompoffAccordion"></div>

      <button
        *ngIf="dates.length > 0"
        class="btn btn-primary mt-4 w-50"
        type="button"
        (click)="submitForm('Comp Off')"
        [disabled]="dates.length === 0"
      >
        Submit
      </button>
    </form>
  </div>
  <!-- end offcanvas-body-->
</div>
<!-- end offcanvas comp off request-->

<!-- create event modal -->
<ng-template #addBusinessModals let-modal>
  <!-- <div class="modal custom-modal fade custom-modal-two modal-padding" id="add_company" role="dialog">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content"> -->
  <div class="modal-header">
    <h5 class="modal-title">{{ title }} Event</h5>
    <button
      type="button"
      class="btn-close custom-btn-close"
      data-bs-dismiss="modal"
      aria-label="Close"
      (click)="onClose()"
    >
      <i class="ti ti-x"></i>
    </button>
  </div>
  <div class="modal-body">
    <form [formGroup]="eventForm">
      <div class="input-block mb-3">
        <label class="col-form-label" for="workStatus"
          >Event Type <span class="text-danger">*</span></label
        >
        <select class="form-select" formControlName="workStatus">
          <option value="" disabled>Select Event Type</option>
          <!-- <option [ngValue]="workStatusEnum.LATE">Late</option>
          <option [ngValue]="workStatusEnum.EARLY">Early</option>
          <option [ngValue]="workStatusEnum.ABSENTHALFDUETOLATE">Absent for Late</option> -->
          <option *ngFor="let event of eventTypes" [ngValue]="event.value">
            {{ event.label }}
          </option>
        </select>

        <div *ngIf="eventForm.get('businessId')?.invalid && eventForm.get('businessId')?.touched">
          <span class="text-danger">
            {{ getErrorMessage('businessId') }}
          </span>
        </div>
      </div>
      <div
        class="input-block mb-3"
        *ngIf="
          eventForm.get('workStatus')?.value &&
          eventForm.get('workStatus')?.value === workStatusEnum.ABSENTHALFDUETOLATE
        "
      >
        <label class="col-form-label" for="clockIn"
          >Absent On <span class="text-danger">*</span></label
        >
        <input
          class="form-control"
          type="datetime-local"
          formControlName="clockIn"
          appTrimInput
          [max]="maxDateTime"
          [min]="minDateTime"
        />
        <div *ngIf="eventForm.get('clockIn')?.invalid && form.get('clockIn')?.touched">
          <span class="text-danger">
            {{ getErrorMessage('clockIn') }}
          </span>
        </div>
      </div>

      <!-- Event Start Time -->
      <div
        class="input-block mb-3"
        *ngIf="
          eventForm.get('workStatus')?.value &&
          eventForm.get('workStatus')?.value !== workStatusEnum.ABSENTHALFDUETOLATE
        "
      >
        <label class="col-form-label" for="clockIn">
          <!-- {{
            eventForm.get('workStatus')?.value === workStatusEnum.LATE ? 'Late Time' : 'Early Time'
          }} -->
          {{ selectedEventLabel }} Start Time <span class="text-danger">*</span></label
        >

        <!-- <input
          class="form-control"
          type="datetime-local"
          formControlName="clockIn"
          appTrimInput
          [max]="maxDateTime"
          [min]="minDateTime"
        /> -->
        <input
          class="form-control"
          type="datetime-local"
          formControlName="clockIn"
          appTrimInput
          [max]="effectiveMaxDateTime"
          [min]="minDateTime"
        />
        <div *ngIf="eventForm.get('clockIn')?.invalid && form.get('clockIn')?.touched">
          <span class="text-danger">
            {{ getErrorMessage('clockIn') }}
          </span>
        </div>
      </div>

      <!-- Event End Time -->

      <div
        class="input-block mb-3"
        *ngIf="
          eventForm.get('workStatus')?.value &&
          eventForm.get('workStatus')?.value !== workStatusEnum.ABSENTHALFDUETOLATE
        "
      >
        <label class="col-form-label" for="clockOut">
          {{ selectedEventLabel }} End Time
          <span class="text-danger">*</span>
        </label>

        <!-- <input
          class="form-control"
          type="datetime-local"
          formControlName="clockOut"
          appTrimInput
          [max]="maxDateTime"
          [min]="eventForm.get('clockIn')?.value || minDateTime"
        /> -->
        <!-- <input
          class="form-control"
          type="datetime-local"
          formControlName="clockOut"
          appTrimInput
          [max]="maxDateTime"
          [min]="eventForm.get('clockIn')?.value?.slice(0, 16) || minDateTime"
        /> -->
        <input
          class="form-control"
          type="datetime-local"
          formControlName="clockOut"
          appTrimInput
          [max]="effectiveMaxDateTime"
          [min]="eventForm.get('clockIn')?.value?.slice(0, 16) || minDateTime"
        />

        <div *ngIf="eventForm.get('clockOut')?.invalid && eventForm.get('clockOut')?.touched">
          <span class="text-danger">
            {{ getErrorMessage('clockOut') }}
          </span>
        </div>
      </div>

      <!-- Event Duration -->
      <div
        class="input-block mb-3"
        *ngIf="
          eventForm.get('workStatus')?.value &&
          eventForm.get('workStatus')?.value !== workStatusEnum.ABSENTHALFDUETOLATE
        "
      >
        <label class="col-form-label" for="clockIn">
          <!-- {{
            eventForm.get('workStatus')?.value === workStatusEnum.LATE ? 'Late By ' : 'Early By '
          }} -->
          {{ selectedEventLabel }} By (ex.: 1h 30m) <span class="text-danger">*</span></label
        >
        <input
          class="form-control"
          type="text"
          formControlName="lateLogin"
          appTrimInput
          maxlength="20"
          readonly
        />
        <div *ngIf="eventForm.get('lateLogin')?.invalid && eventForm.get('lateLogin')?.touched">
          <span class="text-danger">
            {{ getErrorMessage('lateLogin') }}
          </span>
        </div>
      </div>

      <!-- <div class="submit-section">
                  <button class="btn btn-primary submit-btn" (click)="onSubmit()" [disabled]="!form.valid">Submit</button>
                </div> -->
    </form>
  </div>
  <div class="modal-footer">
    <button
      type="button"
      class="btn btn-outline-light border me-2"
      data-bs-dismiss="modal"
      (click)="onClose()"
    >
      Cancel
    </button>
    <button
      type="submit"
      class="btn btn-primary"
      (click)="onSubmit()"
      [disabled]="!eventForm.valid"
    >
      <ng-container *ngIf="isLoading$ | async; else loading">
        <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
        Save...
      </ng-container>
      <ng-template #loading> Create Event </ng-template>
    </button>
  </div>
  <!-- </div>
      </div>
    </div> -->
</ng-template>
<!-- create event modal end -->
